export type PillButtonId =
  | 'run'
  | 'run-advance'
  | 'run-insert'
  | 'type'
  | 'move'
  | 'duplicate'
  | 'add-below'
  | 'inject'
  | 'delete'

/** Canonical render order for the pill. Visibility is controlled by the user's enabled set. */
export const PILL_BUTTON_ORDER: readonly PillButtonId[] = [
  'run',
  'run-advance',
  'run-insert',
  'type',
  'move',
  'duplicate',
  'add-below',
  'inject',
  'delete',
] as const

/** Defaults — what users see out of the box. */
export const PILL_BUTTON_DEFAULTS: readonly PillButtonId[] = [
  'run',
  'type',
  'duplicate',
  'add-below',
  'inject',
  'delete',
] as const

/** Group separators — for any visible button at the START of these IDs, render a separator BEFORE it. */
export const PILL_GROUP_SEPARATORS: readonly PillButtonId[] = ['type', 'delete'] as const

export const isPillButtonId = (v: string): v is PillButtonId =>
  (PILL_BUTTON_ORDER as readonly string[]).includes(v)
